import { render, staticRenderFns } from "./ProfileVideos.vue?vue&type=template&id=1a5ed03b&"
import script from "./ProfileVideos.vue?vue&type=script&lang=js&"
export * from "./ProfileVideos.vue?vue&type=script&lang=js&"
import style0 from "./ProfileVideos.vue?vue&type=style&index=0&id=1a5ed03b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports